"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipFlyoutArrowStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _flyout = require("../../flyout");
const TooltipFlyoutArrowStyled = (0, _styled.default)(_flyout.FlyoutArrow)`
    // Turn off (rest) the default arrow styles from the Flyout so we can do some
    // fancier stuff w/ icons here.
    // We originally thought we might take this code and apply it all to the Flyout so all
    // Flyouts could have the same arrow styling, but that would require also managing the corners
    // of all Flyouts to get the right rounding. We'll have to pass that by UX before we do anything.
    width: 8px;
    height: 8px;
    background-color: transparent;
    border: none;
`;
exports.TooltipFlyoutArrowStyled = TooltipFlyoutArrowStyled;
//# sourceMappingURL=TooltipFlyoutArrowStyled.js.map